


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { versesData } from "../data/versesData";
import { motion } from "framer-motion";

function VerseDetail() {
  const { id } = useParams();
  const [verseData, setVerseData] = useState(null);

  useEffect(() => {
    const verse = versesData.find((v) => v.id === parseInt(id));
    setVerseData(verse);
  }, [id]);

  if (!verseData)
    return (
      <div
        style={{
          textAlign: "center",
          padding: "100px 20px",
          fontFamily: "'Poppins', sans-serif",
          color: "#b66b00",
        }}
      >
        Loading...
      </div>
    );

  const container = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.25 } },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const cardHover = {
    hover: { scale: 1.03, boxShadow: "0 8px 25px rgba(255,200,120,0.4)" },
  };

  return (
    <div
      className="container-fluid"
      style={{
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(180deg, #fffaf3 0%, #fff3e1 50%, #fff 100%)",
        minHeight: "100vh",
        padding: "50px 20px",
      }}
    >
      {/* 🕉️ Verse Header */}
      <motion.section
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center"
        style={{
          background: "linear-gradient(135deg, #ffe7c2, #fff3e1, #fff9f3)",
          padding: "25px 10px",
          borderRadius: "18px",
          boxShadow: "0 8px 25px rgba(255,200,150,0.3)",
          maxWidth: "420px",
          margin: "0 auto",
          border: "2px solid rgba(255,200,150,0.6)",
        }}
      >
        <h3
          style={{
            fontWeight: "800",
            fontSize: "2.5rem",
            color: "#a06500ff",
            textShadow: "0 2px 8px rgba(255,180,120,0.5)",
          }}
        >
          Verse {verseData.id}
        </h3>
      </motion.section>

      {/* Sanskrit & Transliteration */}
      <motion.div
        className="row mt-5 justify-content-center"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {/* Sanskrit */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            className="card"
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(145deg, #fff3e1, #fffaf3)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,190,120,0.5)",
              boxShadow: "0 6px 20px rgba(255,180,100,0.2)",
            }}
          >
            <h2
              style={{
                color: "#b66b00",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              संस्कृत / Sanskrit
            </h2>
            <div style={{ fontSize: "1.3rem", color: "#5a3a0e" }}>
              {verseData.sanskrit.split("\n").map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </motion.div>
        </motion.div>

        {/* Transliteration */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            className="card"
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(145deg, #fffaf3, #fff5e0)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,190,120,0.5)",
              boxShadow: "0 6px 20px rgba(255,180,100,0.2)",
            }}
          >
            <h2 style={{ color: "#b66b00", fontWeight: "700" }}>
              Transliteration
            </h2>
            <div
              style={{
                fontSize: "1.3rem",
                color: "#4b2e05",
                marginTop: "10px",
              }}
            >
              {verseData.transliteration.split("\n").map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Meanings */}
      <motion.div
        className="row mt-5 justify-content-center"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {/* English */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(145deg, #fff, #fffaf3)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,200,150,0.4)",
              boxShadow: "0 6px 18px rgba(255,190,120,0.2)",
            }}
          >
            <h2 style={{ color: "#b66b00", fontWeight: "700" }}>
              English Meaning
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#4b2e05",
                marginTop: "10px",
                lineHeight: "1.8",
              }}
            >
              {verseData.english}
            </p>
          </motion.div>
        </motion.div>

        {/* Hindi */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(145deg, #fffaf3, #fff3e1)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,200,150,0.4)",
              boxShadow: "0 6px 18px rgba(255,190,120,0.2)",
            }}
          >
            <h2 style={{ color: "#b66b00", fontWeight: "700" }}>
              Hindi Translation
            </h2>
            <div
              style={{
                fontSize: "1.2rem",
                color: "#4b2e05",
                marginTop: "10px",
                lineHeight: "1.8",
              }}
            >
              {verseData.hindi.split("\n").map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Benefits & Audio */}
      <motion.div
        className="row mt-5 justify-content-center"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {/* Benefits */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(135deg, #fff3e1, #ffe7c2)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,190,120,0.4)",
              boxShadow: "0 6px 20px rgba(255,190,120,0.3)",
            }}
          >
            <h2 style={{ color: "#b66b00", fontWeight: "700" }}>Benefits</h2>
            <div
              style={{
                fontSize: "1.2rem",
                color: "#4b2e05",
                marginTop: "10px",
                lineHeight: "1.8",
              }}
            >
              {verseData.benefits.split("\n").map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </motion.div>
        </motion.div>

        {/* Audio */}
        <motion.div
          className="col-lg-6 col-md-10 col-sm-12 mb-4"
          variants={fadeUp}
        >
          <motion.div
            whileHover="hover"
            variants={cardHover}
            style={{
              background: "linear-gradient(145deg, #fffaf3, #fff3e1)",
              borderRadius: "18px",
              padding: "25px",
              textAlign: "center",
              border: "2px solid rgba(255,200,150,0.5)",
              boxShadow: "0 6px 20px rgba(255,190,120,0.3)",
            }}
          >
            <h2 style={{ color: "#b66b00", fontWeight: "700" }}>
              Listen to the Audio
            </h2>
            <audio
              controls
              style={{
                width: "100%",
                marginTop: "15px",
                borderRadius: "8px",
                outline: "none",
              }}
            >
              <source src={verseData.audio} type="audio/mpeg" />
            </audio>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* 📱 Responsive Tweaks */}
      <style>
        {`
          @media (max-width: 992px) {
            h2 { font-size: 1.8rem !important; }
            p { font-size: 1.05rem !important; }
            audio { width: 100% !important; }
          }

          @media (max-width: 576px) {
            h3 { font-size: 2rem !important; }
            h2 { font-size: 1.5rem !important; }
            p { font-size: 1rem !important; line-height: 1.6; }
            .card { padding: 18px !important; border-radius: 14px !important; }
          }
        `}
      </style>
    </div>
  );
}

export default VerseDetail;
